// export const ip = "http://localhost:8080"
export const ip = "https://alumni-nec.herokuapp.com"

